var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fallback-image"},[(_vm.$slots.default)?_vm._t("default"):_c('aspect-ratio',{staticClass:"is-fallback-image",attrs:{"ratio":"4x3"}},[_c('lazy-icon',{attrs:{"icon":"images"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }